module.exports = __webpack_public_path__ + "static/media/bars.299eba22.png";